import { render, staticRenderFns } from "./ProductDetailsV2.vue?vue&type=template&id=7f577abe&scoped=true&"
import script from "./ProductDetailsV2.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsV2.vue?vue&type=style&index=0&id=7f577abe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f577abe",
  null
  
)

export default component.exports